<template>
  <PageTemplate>
    <Loader v-if="!isLoaded"/>
    <div v-else>
      <div class="d-flex justify-content-between align-items-center">
        <h6 class="element-header">
          Time management
        </h6>
      </div>
      <div class="element-box">
        <div class="d-flex justify-content-between mb-5 flex-md-row flex-column ">
          <h5>
            Mitarbeiter - Monatsübersicht (HR Übersicht)
          </h5>
          <button class="btn btn-primary custom_search_button2 w-auto ml-2"
                  @click="router.push({ name: 'annualOverview' });">
            Jahresübersicht
          </button>
        </div>

          <Search
              :userDropdown="userDropdown"
              :filters="filters"
              :loading="isSearching"
              :monthsInYearDropdown="enums.monthsInYear"
              :yearsDropdown="yearsDropdown"
              @search="getMonthlyOverviewHr"/>

        <div class="row align-items-center justify-content-between mt-3">
          <div>
            <PerPage :values="[10, 25, 50, 100]" @update:perPage="getMonthlyOverviewHr"/>
            <ExcelExportButton
                :label="$t('general.excel_export')"
                :loading="isExcelLoaded"
                @click="getExcelExport"/>
          </div>
        </div>

        <div class="table-responsive overflow-auto mt-3">
          <table class="table table-striped">
            <thead>
            <tr>
              <th style=" text-align: left; padding-right: 30px; min-width: 150px;">{{ $t('general.actions') }}</th>
              <th>Mitarbeiternr</th>
              <th class="text-right">Arbeitszeit</th>
              <th class="text-right">Soll</th>
              <th class="text-right">Überstunden</th>
              <th class="text-right">davon im Einsatz</th>
              <th class="text-right">Arbeitstage pro Monat</th>
              <th class="text-right">Urlaub</th>
              <th class="text-right">Sonderurlaub</th>
              <th class="text-right">Krankheitstage</th>
              <th class="text-right">Abgehaltene Einheiten</th>
              <th class="text-right">Arbeitsleistung %</th>
              <th class="text-center">Eingereicht zur Überprüfung</th>
              <th class="text-center">Akzeptiert/Genehmigt</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(monthlyOverview) in monthlyOverviewList.data" :key="monthlyOverview.id">
              <td>
<!--                div class="btn-group dropup">-->
                <div class="btn-group dropup">
                  <button type="button" class="btn btn-primary dropdown-toggle"
                          data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    Aktion
                  </button>
                  <div class="dropdown-menu">
                    <button class="dropdown-item"
                            @click="router.push({ name: 'overview', params: { id: monthlyOverview.user.id } });">
                      Übersicht
                    </button>

                    <button class="dropdown-item"
                            @click="router.push({ name: 'hourlyOverview', params: { id: monthlyOverview.user.id } });">
                      Stundenerfassung
                    </button>

                    <button class="dropdown-item" v-if="hasRoleAdminOrPersonal && monthlyOverview.pendingRequest"
                            @click="handleApproveModal(monthlyOverview)">
                      Genehmigt
                    </button>

                    <button class="dropdown-item" v-if="hasRoleAdminOrPersonal &&
                    (monthlyOverview.pendingRequest || monthlyOverview.approvedRequest)"
                            @click="handleDeclineModal(monthlyOverview)">
                      Abgelehnt
                    </button>
                  </div>
                </div>
              </td>
              <td>{{ monthlyOverview?.user?.fullName }}</td>
              <td class="text-right">{{ monthlyOverview?.workedHours }}</td>
              <td class="text-right">{{ monthlyOverview?.planedHours }}</td>
              <td class="text-right">{{ monthlyOverview?.overtimeHours }}</td>
              <td class="text-right">{{ monthlyOverview?.recalculatedPlanedHours }}</td>
              <td class="text-right">{{ monthlyOverview?.numberOfPlanedWorkingDays }}</td>
              <td class="text-right">{{ monthlyOverview?.numberOfVacationDays }}</td>
              <td class="text-right">{{ monthlyOverview?.numberOfSpecialLeaveDays }}</td>
              <td class="text-right">{{ monthlyOverview?.numberOfSickDays }}</td>
              <td class="text-right">{{ monthlyOverview?.unitsDone }}</td>
              <td class="text-right">{{ monthlyOverview?.workPerformance }}</td>
              <td class="text-center">
                <span v-if="hasRoleAdminOrPersonal && monthlyOverview.pendingRequest"
                      style="background-color: orange; padding: 9px 14px; border-radius: 50%;">!</span>
              </td>
              <td class="text-center">
                <span v-if="hasRoleAdminOrPersonal && monthlyOverview.approvedRequest"
                      style="background-color: #43ad4e; color: white; padding: 9px 12px; border-radius: 50%;">✓</span>
              </td>
            </tr>
            </tbody>
          </table>
          <div v-if=" monthlyOverviewList.data.length === 1" style="height: 140px">

          </div>
        </div>
        <Pagination v-if="monthlyOverviewList?.pagination?.total_pages > 1"
                    :totalPages="monthlyOverviewList?.pagination?.total_pages"
                    :currentPage="monthlyOverviewList?.pagination?.current_page"
                    :totalItems="monthlyOverviewList?.pagination?.total_items"
                    :perPage="monthlyOverviewList?.pagination?.items_per_page"
                    @pagechanged="getMonthlyOverviewHr"/>
      </div>
    </div>

    <ModalConfirm
        v-model="showApproveModal"
        :header="'Monat genehmigen'"
        :subHeader="`${userFullNameOnActions} - ${yearOnActions} ${monthOnActions}`"
        confirmationQuestion="Sind Sie sicher, dass Sie den Monat genehmigen möchten?"
        :onConfirm="approveMonth"/>

    <ModalDecline
        v-model="showDeclineModal"
        :confirmationQuestion="t('general.decline_question')"
        header=""
        :subHeader="`${userFullNameOnActions} - ${yearOnActions} ${monthOnActions}`"
        :onConfirm="declineMonth"/>

  </PageTemplate>
</template>

<script setup>
import { timeManagementService } from '@/api/TImeManagement';
import Loader from '@/components/Loader.vue';
import ModalConfirm from '@/components/modal/ModalConfirm.vue';
import ModalDecline from '@/components/modal/ModalDecline.vue';
import PageTemplate from '@/components/PageTemplate.vue';
import Pagination from '@/components/Pagination.vue';
import PerPage from '@/components/PerPage.vue';
import { CloseToast, ErrorToast, SuccessToast } from '@/components/VueToast';
import router from '@/router';
import { getUsersForHrOverviewDropdown, getYears } from '@/shared/dropdowns';
import { downloadFile } from '@/shared/functions';
import { piniaEnumsStore } from '@/store/piniaEnumsStore';
import { piniaUserStore } from '@/store/piniaUserStore';
import Search from '@/views/App/TimeManagement/TMMonthlyOverview/Search.vue';
import { computed, onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';
import ExcelExportButton from '@/components/ExcelExportButton.vue';

const { t }                 = useI18n();
const piniaUserState        = piniaUserStore();
const piniaCurrentUser      = computed(() => piniaUserState.currentUser.user);
const yearsDropdown         = ref([]);
const userDropdown          = ref([]);
const { enums }             = piniaEnumsStore();
const isLoaded              = ref(false);
const isExcelLoaded         = ref(false);
const monthlyOverviewList   = ref([]);
const route                 = useRoute();
const showApproveModal      = ref(false);
const showDeclineModal      = ref(false);
const userFullNameOnActions = ref('');
const yearOnActions         = ref('');
const monthOnActions        = ref('');
const actionsData           = ref({});
const currentDate           = new Date();

let year   = route.query.year;
let month  = route.query.month;
let userId = route.query.userId;

if(userId === undefined){
  userId = null
}

if (!year) {
  year = yearsDropdown.value.at(-1)?.value || new Date().getFullYear();
}
if (!month) {
  month = currentDate.getMonth() + 1;
}
if(userId){
  userId = +userId;
}

const filters = ref({
  userId: userId,
  year: +year,
  month: +month,
});

const allowedRolesForActions = [ 'ROLE_ADMIN', 'ROLE_PERSONAL', 'ROLE_HEAD_OF_HR' ];

const hasRoleAdminOrPersonal = computed(() => {
  return allowedRolesForActions.some(role => piniaCurrentUser.value.roles.includes(role));
});

const isSearching = ref(false);

async function getExcelExport() {
  await downloadFile(
      '/time-management/monthly-overview-excel-export-hr',
      undefined, {...filters.value}, false, 'GET', isExcelLoaded)
}

async function getMonthlyOverviewHr(page = 1, perPage, passedFilters) {
  CloseToast();

  if (passedFilters) {
    isSearching.value = true;
  }

  try {
    const perPageRes = monthlyOverviewList.value?.pagination?.items_per_page;
    const { data }   = await timeManagementService.getMonthlyOverviewHr({
          page: page,
          limit: perPage ?? perPageRes,
          ...(passedFilters ? passedFilters : filters.value),
        },
    );

    monthlyOverviewList.value = data;
    isSearching.value         = false;
  } catch (error) {
    await ErrorToast(error);
    isSearching.value = false;
  }
}

function handleApproveModal(data) {
  CloseToast();
  actionsData.value           = {};
  actionsData.value           = {
    userId: data?.user?.id,
    year: Number(data?.year),
    month: Number(data?.month),
  };
  userFullNameOnActions.value = data?.user?.fullName;
  yearOnActions.value         = data?.year;
  monthOnActions.value        = t(`calendar.months_number_key.${Number(data?.month)}`);
  showApproveModal.value      = true;
  showDeclineModal.value      = false;
}

function handleDeclineModal(data) {
  CloseToast();
  actionsData.value           = {};
  actionsData.value           = {
    userId: data?.user?.id,
    year: Number(data?.year),
    month: Number(data?.month),
  };
  userFullNameOnActions.value = data?.user?.fullName;
  yearOnActions.value         = data?.year;
  monthOnActions.value        = t(`calendar.months_number_key.${Number(data?.month)}`);
  showDeclineModal.value      = true;
  showApproveModal.value      = false;
}

async function approveMonth() {
  try {
    await timeManagementService.approveMonth(
        actionsData.value.userId,
        actionsData.value.year,
        actionsData.value.month,
    );
    await getMonthlyOverviewHr();

    showApproveModal.value = false;
    showDeclineModal.value = false;
    actionsData.value      = {};
    SuccessToast(t('general.toasts.delete_success'));
  } catch (error) {
    await ErrorToast(error);
  }
}

async function declineMonth() {
  try {
    await timeManagementService.declineMonth(
        actionsData.value.userId,
        actionsData.value.year,
        actionsData.value.month,
    );
    await getMonthlyOverviewHr();

    showApproveModal.value = false;
    showDeclineModal.value = false;
    actionsData.value      = {};
    SuccessToast(t('general.toasts.delete_success'));
  } catch (error) {
    await ErrorToast(error);
  }
}

onMounted(async () => {
  await Promise.all([
    getYears(yearsDropdown),
    getMonthlyOverviewHr(),
    getUsersForHrOverviewDropdown(userDropdown),
  ]);

  isLoaded.value = true;
});
</script>

<style scoped>
.nav.sm {
  width: max-content;
}
</style>